import React from 'react';
import BankImportPage from './BankImportPage';

export default function ASNBankPage() {
  return (
    <BankImportPage
      title="ASN Bank Import"
      description="Import ASN Bank transactions using the standard CSV export (Datum, Je rekening, Van / naar, Naam, Valuta, Bedrag bij / af, Valutadatum, Omschrijving, Betalingskenmerk, Type, Code, Volgnummer)."
      fieldLabels={['Date', 'Account', 'Counterparty', 'Name', 'Currency', 'Amount', 'Value Date', 'Description', 'Payment Reference', 'Type', 'Code']}
      listEndpoint="/api/asn"
      importEndpoint="/api/asn/import"
      bankId="ASN"
      emptyText="No ASN Bank records found."
    />
  );
}
